module.exports = __webpack_public_path__ + "static/media/cup-3.bbf90390.svg";